import PropTypes from "prop-types";

// Image PropTypes
export const imageProps = PropTypes.shape({
  url: PropTypes.string.isRequired,
  width: PropTypes.number, // Optional in Image.js
  height: PropTypes.number, // Optional in Image.js
  alt: PropTypes.string, // Optional 'alt' text for the image
});

// Callout PropTypes
export const calloutProps = PropTypes.shape({
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});

// Content Block PropTypes
export const contentBlockProps = PropTypes.shape({
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.shape({
    paragraph: PropTypes.string,
    image: imageProps,
    youtubeVideo: PropTypes.string,
    callout: calloutProps,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        content: PropTypes.object, // Recursive reference
      })
    ),
  }).isRequired,
});

// Content Props (used in ContentBuilder)
export const contentProps = PropTypes.oneOfType([
  PropTypes.arrayOf(contentBlockProps), // When content is an array
  contentBlockProps,
]);

export default {
  imageProps,
  calloutProps,
  contentBlockProps,
  contentProps,
};
